import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaLightbulb, FaLaptopHouse, FaRocket } from 'react-icons/fa';
import './FooterPages.css';

const Careers = () => {
    return (
        <div className="footer-page-container">
            <div className="footer-page-inner">
                <Link to="/" className="footer-back-btn">
                    <FaArrowLeft /> Back to Home
                </Link>

                <div className="footer-header">
                    <h1 className="footer-title">Join Our Mission</h1>
                    <p className="footer-subtitle">
                        Help us bridge the gap between academia and industry. We are looking for passionate individuals to build the future of education.
                    </p>
                </div>

                <div className="footer-grid-section" style={{ marginBottom: '4rem' }}>
                    <div className="footer-glass-card">
                        <div className="card-icon"><FaLightbulb /></div>
                        <h3>Innovation First</h3>
                        <p>We push boundaries. Work on cutting-edge AI matching algorithms and secure escrow payment systems.</p>
                    </div>
                    <div className="footer-glass-card">
                        <div className="card-icon"><FaLaptopHouse /></div>
                        <h3>Remote-First Culture</h3>
                        <p>Work from anywhere. We believe in output over hours and flexibility that fits your life.</p>
                    </div>
                    <div className="footer-glass-card">
                        <div className="card-icon"><FaRocket /></div>
                        <h3>Impact Driven</h3>
                        <p>Your code directly impacts students' careers and institutions' capabilities. Make a difference.</p>
                    </div>
                </div>

                <div className="footer-text-section">
                    <h2 style={{ textAlign: 'center', marginBottom: '2.5rem' }}>Open Positions</h2>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        {[
                            { title: 'Senior Full Stack Engineer', dept: 'Engineering', type: 'Remote' },
                            { title: 'Product Designer (UX/UI)', dept: 'Design', type: 'Remote' },
                            { title: 'University Partnership Manager', dept: 'Sales', type: 'Hybrid' },
                            { title: 'Customer Success Specialist', dept: 'Support', type: 'Remote' }
                        ].map((job, index) => (
                            <div key={index} style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '1.5rem',
                                background: 'rgba(30, 41, 59, 0.4)',
                                borderRadius: '12px',
                                border: '1px solid rgba(71, 85, 105, 0.4)',
                                transition: 'all 0.2s'
                            }}>
                                <div>
                                    <h4 style={{ fontSize: '1.15rem', color: '#f8fafc', margin: 0, fontWeight: '600' }}>{job.title}</h4>
                                    <p style={{ color: 'var(--text-faint)', margin: '0.4rem 0 0 0', fontSize: '0.9rem' }}>{job.dept} • {job.type}</p>
                                </div>
                                <button className="footer-cta-btn" style={{ padding: '8px 20px', marginTop: 0, fontSize: '0.9rem' }}>
                                    Apply
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="footer-text-section" style={{ textAlign: 'center' }}>
                    <h2>Don't see your role?</h2>
                    <p style={{ marginBottom: '2rem' }}>
                        We are always looking for exceptional talent. Send your resume to careers@EdVergenceX.com.
                    </p>
                    <Link to="/contact" className="footer-cta-btn">
                        Contact Us
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Careers;
